import React from 'react';
import { Grid, Typography, Box, Chip } from '@mui/material';
import { TutorProfile } from '../../services/interfaces';

interface ProfileSubjectsProps {
    profile: TutorProfile;
}

const ProfileSubjects: React.FC<ProfileSubjectsProps> = ({ profile }) => {
    return (
        <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
                Subjects
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {profile.subjects?.map((subject, index) => (
                    <Chip key={index} label={subject} color="primary" variant="outlined" />
                ))}
                {(!profile.subjects || profile.subjects.length === 0) && (
                    <Typography variant="body2" color="text.secondary">
                        No subjects listed.
                    </Typography>
                )}
            </Box>
        </Grid>
    );
};

export default ProfileSubjects;
